const imageUrl = {
  carousel: process.env.REACT_APP_API_IMAGE_URL + 'carousel/',
  gallery: process.env.REACT_APP_API_IMAGE_URL + 'gallery/',
  testimony: process.env.REACT_APP_API_IMAGE_URL + 'testimony/',
  blog: process.env.REACT_APP_API_IMAGE_URL + 'blog/',
  header: process.env.REACT_APP_API_IMAGE_URL + 'header/',
  team: process.env.REACT_APP_API_IMAGE_URL + 'team/',
  company: process.env.REACT_APP_API_IMAGE_URL + 'company/',
};

export default imageUrl;